export default __webpack_public_path__ + "static/media/lerna.8cf0d6c6.png";